import { defaultConfig } from 'config/default'
import * as yup from 'yup'
import { yupResolver } from '@hookform/resolvers/yup'
import { useTranslation } from 'react-i18next'
import { useContext } from 'react'
import { StoreSettingsContext } from 'store'

export const useAddProductValidationSchema = () => {
	const { t } = useTranslation()
	const storeCtx = useContext(StoreSettingsContext)

	const yupCostPrice = storeCtx?.storeSettings?.cost_price_enabled
		? yup.string().matches(/^[0-9]+$/, t('Price must be an integer'))
		: yup.string()

	const productValidationSchema = yup.object({
		name: yup
			.string()
			.required(t('Title is required'))
			.max(
				defaultConfig.maxProductNameLength,
				t('Max product name length is {{ length }}', { length: defaultConfig.maxProductNameLength })
			),
		booking: yup.object({
			value: yup.string().required(t('Booking is required')).nullable()
		}),
		size: yup
			.string()
			.max(
				defaultConfig.maxProductSizeLength,
				t('Max size length is {{ length }}', { length: defaultConfig.maxProductSizeLength })
			),
		quantity: yup
			.string()
			.default('1')
			.matches(/^[0-9]+$/, t('Quantity must be an integer'))
			.required(t('Quantity is required')),
		price: yup
			.string()
			.matches(/^[0-9]+$/, t('Price must be an integer'))
			.required(t('Price is required')),
		cost_price: yupCostPrice
	})

	return yupResolver(productValidationSchema)
}
